import { Http } from '@/services/http'
import { Injectable } from '@tanbo/vue-di-plugin'
import { InvokeThrottle } from '@/common/decorators/invoke-throttle'
import { ParamsClean } from '@/common/decorators/params-clean'
import { ClientItem } from '@/views/dashboard/_type/client-item'

/** 获取子网设置请求 */
export interface GetSubnetSettingsReq {
  /** 子网id */
  id?: number
}

/** 子网设置获取 */
export interface SubnetSettings {
  /** 指定终端id集合 */
  device_ids?: string[]
  /** 子网id */
  id?: number
  /** 子网地址 */
  subnet_address?: string
  /** 扫描模式（1-指定终端，2-自动分配） */
  scan_mode?: number
  /** 备注 */
  remarks?: string
}

/** 编辑子网请求 */
export interface EditSubnetReq {
  /** 子网地址 */
  subnet_address: string
  /** 扫描模式（1-指定终端，2-自动分配） */
  scan_model: number
  /** 指定终端列表 */
  device_ids?: string[]
  /** 子网id */
  id?: number
  /** 备注 */
  remarks?: string
}

export interface GetTerminalListReq {
  device_ids: string[]
  page?: number
  limit?: number
  group_id?: number
  is_auth?: boolean
  permission_names?: string[]
}

export interface GetTerminalListRes {
  total: number
  terminal_list: ClientItem[]
}

@Injectable()
export class EditSubnetDrawerService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  getSubnetSettings (data: GetSubnetSettingsReq) {
    return this.http.post<SubnetSettings>('/client_find/subnet_get', data)
  }

  @InvokeThrottle()
  editSubnet (data: EditSubnetReq) {
    return this.http.post<void>('/client_find/subnet_edit', data)
  }

  @ParamsClean()
  @InvokeThrottle()
  getTerminalListByDeviceIds (data: GetTerminalListReq) {
    return this.http.post<GetTerminalListRes>('/terminal/list', data)
  }
}

